
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/city_legacy",
      function () {
        return require("private-next-pages/city_legacy.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/city_legacy"])
      });
    }
  